import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ContactForm.css';

interface SubmitButtonProps {
  isSubmitting: boolean;
  disabled?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  disabled = false
}) => {
  const { t } = useTranslation();

  return (
    <button 
      type="submit" 
      disabled={disabled || isSubmitting}
      className="submit-button"
      aria-describedby="submit-status"
      aria-live="polite"
      aria-busy={isSubmitting}
    >
      {isSubmitting ? (
        <>
          <span className="loading-spinner" aria-hidden="true"></span>
          <span className="sr-only">{t('accessibility.submitting')}</span>
          {t('form.submit.submitting')}
        </>
      ) : (
        t('form.submit.button')
      )}
    </button>
  );
};

export default SubmitButton;

